module.exports = __webpack_public_path__ + "static/media/address-empty-label.eba9f6c7.svg";